import { has, isArray } from 'lodash';

import {
  requestApiGet,
  requestApiPost
} from '../parts/common/requestUtils';
import { getSessionIp } from '../parts/session/sessionUtils';

export const FETCH_CAMPAIGN_SEARCH_START = 'FETCH_CAMPAIGN_SEARCH_START';
export const FETCH_CAMPAIGN_SEARCH_SUCCESS = 'FETCH_CAMPAIGN_SEARCH_SUCCESS';
export const FETCH_CAMPAIGN_SEARCH_ERROR = 'FETCH_CAMPAIGN_SEARCH_ERROR';

export const FETCH_TEAM_SEARCH_START = 'FETCH_TEAM_SEARCH_START';
export const FETCH_TEAM_SEARCH_SUCCESS = 'FETCH_TEAM_SEARCH_SUCCESS';
export const FETCH_TEAM_SEARCH_ERROR = 'FETCH_TEAM_SEARCH_ERROR';

export const FETCH_TEAM_AND_PARTICIPANT_SEARCH_START = 'FETCH_TEAM_AND_PARTICIPANT_SEARCH_START';
export const FETCH_TEAM_AND_PARTICIPANT_SEARCH_SUCCESS = 'FETCH_TEAM_AND_PARTICIPANT_SEARCH_SUCCESS';
export const FETCH_TEAM_AND_PARTICIPANT_SEARCH_ERROR = 'FETCH_TEAM_AND_PARTICIPANT_SEARCH_ERROR';

export const FETCH_PARTICIPANT_SEARCH_START = 'FETCH_PARTICIPANT_SEARCH_START';
export const FETCH_PARTICIPANT_SEARCH_SUCCESS = 'FETCH_PARTICIPANT_SEARCH_SUCCESS';
export const FETCH_PARTICIPANT_SEARCH_ERROR = 'FETCH_PARTICIPANT_SEARCH_ERROR';

export const FETCH_DONATION_SEARCH_START = 'FETCH_DONATION_SEARCH_START';
export const FETCH_DONATION_SEARCH_SUCCESS = 'FETCH_DONATION_SEARCH_SUCCESS';
export const FETCH_DONATION_SEARCH_ERROR = 'FETCH_DONATION_SEARCH_ERROR';

export const FETCH_TRANSACTION_SEARCH_START = 'FETCH_TRANSACTION_SEARCH_START';
export const FETCH_TRANSACTION_SEARCH_SUCCESS = 'FETCH_TRANSACTION_SEARCH_SUCCESS';
export const FETCH_TRANSACTION_SEARCH_ERROR = 'FETCH_TRANSACTION_SEARCH_ERROR';

export const FETCH_PARTICIPATION_SEARCH_START = 'FETCH_PARTICIPATION_SEARCH_START';
export const FETCH_PARTICIPATION_SEARCH_SUCCESS = 'FETCH_PARTICIPATION_SEARCH_SUCCESS';
export const FETCH_PARTICIPATION_SEARCH_ERROR = 'FETCH_PARTICIPATION_SEARCH_ERROR';

export const FETCH_MEMBER_TRANSACTIONS_SEARCH_START = 'FETCH_MEMBER_TRANSACTIONS_SEARCH_START';
export const FETCH_MEMBER_TRANSACTIONS_SEARCH_SUCCESS = 'FETCH_MEMBER_TRANSACTIONS_SEARCH_SUCCESS';
export const FETCH_MEMBER_TRANSACTIONS_SEARCH_ERROR = 'FETCH_MEMBER_TRANSACTIONS_SEARCH_ERROR';

export const FETCH_PLATFORM_MEMBERS_SEARCH_START = 'FETCH_PLATFORM_MEMBERS_SEARCH_START';
export const FETCH_PLATFORM_MEMBERS_SEARCH_SUCCESS = 'FETCH_PLATFORM_MEMBERS_SEARCH_SUCCESS';
export const FETCH_PLATFORM_MEMBERS_SEARCH_ERROR = 'FETCH_PLATFORM_MEMBERS_SEARCH_ERROR';

export const FETCH_PLATFORM_MEMBERS_PARTICIPATIONS_SEARCH_START = 'FETCH_PLATFORM_MEMBERS_PARTICIPATIONS_SEARCH_START';
export const FETCH_PLATFORM_MEMBERS_PARTICIPATIONS_SEARCH_SUCCESS = 'FETCH_PLATFORM_MEMBERS_PARTICIPATIONS_SEARCH_SUCCESS';
export const FETCH_PLATFORM_MEMBERS_PARTICIPATIONS_SEARCH_ERROR = 'FETCH_PLATFORM_MEMBERS_PARTICIPATIONS_SEARCH_ERROR';

export const FETCH_PLATFORM_MEMBERS_TRANSACTIONS_SEARCH_START = 'FETCH_PLATFORM_MEMBERS_TRANSACTIONS_SEARCH_START';
export const FETCH_PLATFORM_MEMBERS_TRANSACTIONS_SEARCH_SUCCESS = 'FETCH_PLATFORM_MEMBERS_TRANSACTIONS_SEARCH_SUCCESS';
export const FETCH_PLATFORM_MEMBERS_TRANSACTIONS_SEARCH_ERROR = 'FETCH_PLATFORM_MEMBERS_TRANSACTIONS_SEARCH_ERROR';

export const FETCH_PLUGIN_SEARCH_START = 'FETCH_PLUGIN_SEARCH_START';
export const FETCH_PLUGIN_SEARCH_SUCCESS = 'FETCH_PLUGIN_SEARCH_SUCCESS';
export const FETCH_PLUGIN_SEARCH_ERROR = 'FETCH_PLUGIN_SEARCH_ERROR';

export const FETCH_SETTLEMENT_REPORTS_START = 'FETCH_SETTLEMENT_REPORTS_START';
export const FETCH_SETTLEMENT_REPORTS_SUCCESS = 'FETCH_SETTLEMENT_REPORTS_SUCCESS';
export const FETCH_SETTLEMENT_REPORTS_ERROR = 'FETCH_SETTLEMENT_REPORTS_ERROR';

export const FETCH_TEAMLESS_SEARCH_START = 'FETCH_TEAMLESS_SEARCH_START';
export const FETCH_TEAMLESS_SEARCH_SUCCESS = 'FETCH_TEAMLESS_SEARCH_SUCCESS';
export const FETCH_TEAMLESS_SEARCH_ERROR = 'FETCH_TEAMLESS_SEARCH_ERROR';

export const FETCH_MESSAGES_SEARCH_START = 'FETCH_MESSAGES_SEARCH_START';
export const FETCH_MESSAGES_SEARCH_SUCCESS = 'FETCH_MESSAGES_SEARCH_SUCCESS';
export const FETCH_MESSAGES_SEARCH_ERROR = 'FETCH_MESSAGES_SEARCH_ERROR';

export const FETCH_DRAFTS_SEARCH_START = 'FETCH_DRAFTS_SEARCH_START';
export const FETCH_DRAFTS_SEARCH_SUCCESS = 'FETCH_DRAFTS_SEARCH_SUCCESS';
export const FETCH_DRAFTS_SEARCH_ERROR = 'FETCH_DRAFTS_SEARCH_ERROR';

export const FETCH_CAMPAIGN_RECIPIENTS_SEARCH_START = 'FETCH_CAMPAIGN_RECIPIENTS_SEARCH_START';
export const FETCH_CAMPAIGN_RECIPIENTS_SEARCH_SUCCESS = 'FETCH_CAMPAIGN_RECIPIENTS_SEARCH_SUCCESS';
export const FETCH_CAMPAIGN_RECIPIENTS_SEARCH_ERROR = 'FETCH_CAMPAIGN_RECIPIENTS_SEARCH_ERROR';

export const FETCH_TEAM_RECIPIENTS_SEARCH_START = 'FETCH_TEAM_RECIPIENTS_SEARCH_START';
export const FETCH_TEAM_RECIPIENTS_SEARCH_SUCCESS = 'FETCH_TEAM_RECIPIENTS_SEARCH_SUCCESS';
export const FETCH_TEAM_RECIPIENTS_SEARCH_ERROR = 'FETCH_TEAM_RECIPIENTS_SEARCH_ERROR';

export const FETCH_MEMBER_RECIPIENTS_SEARCH_START = 'FETCH_MEMBER_RECIPIENTS_SEARCH_START';
export const FETCH_MEMBER_RECIPIENTS_SEARCH_SUCCESS = 'FETCH_MEMBER_RECIPIENTS_SEARCH_SUCCESS';
export const FETCH_MEMBER_RECIPIENTS_SEARCH_ERROR = 'FETCH_MEMBER_RECIPIENTS_SEARCH_ERROR';

export const FETCH_FLAGGED_SEARCH_START = 'FETCH_FLAGGED_SEARCH_START';
export const FETCH_FLAGGED_SEARCH_SUCCESS = 'FETCH_FLAGGED_SEARCH_SUCCESS';
export const FETCH_FLAGGED_SEARCH_ERROR = 'FETCH_FLAGGED_SEARCH_ERROR';

export const CLEAR_SEARCH = 'CLEAR_SEARCH';

export function searchCampaigns(
  platformId,
  _search = null,
  filters = {},
  pagination = {},
  orderBy = null,
  authentication = false,
  showChildrenCount = false,
  showActions = false
) {
  return dispatch => {
    dispatch({ type: FETCH_CAMPAIGN_SEARCH_START });

    const pageNumber =
      (pagination && pagination.current) || (pagination && pagination.pageNumber) || 1;
    const pageResults =
      (pagination && pagination.pageSize) || (pagination && pagination.pageResults) || null;

    orderBy =
      orderBy && (has(orderBy, 'orderBy') || typeof orderBy === 'string')
        ? typeof orderBy === 'string'
          ? { orderBy: orderBy }
          : orderBy
        : { orderBy: 'addedOn[desc]' };

    const search = _search || (filters && filters.search) || undefined;
    if (filters) delete filters.search;

    let formatedFilters = formatFilters(filters);

    const params = {
      filterBy: formatedFilters,
      ...orderBy,
      search,
      pageNumber,
      pageResults,
      ...(showChildrenCount ? { showChildrenCount: true } : {}),
      ...(showActions ? { showActions: true } : {})
    };

    const headers = {
      ...(authentication ? { authentication: 'true' } : {}),
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/platforms/${platformId}/campaigns`,
      params,
      headers
    )
      .then(result => {
        return dispatch({ type: FETCH_CAMPAIGN_SEARCH_SUCCESS, payload: result });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_CAMPAIGN_SEARCH_ERROR,
          payload: error,
          filters: filters,
          search: search
        });
      });
  };
}

export function searchTeams(
  platformId,
  _search = null,
  filters = {},
  pagination = {},
  orderBy = null,
  authentication = false,
  showChildrenCount = false,
  showActions = false
) {
  return dispatch => {
    dispatch({ type: FETCH_TEAM_SEARCH_START });
    const pageNumber =
      (pagination && pagination.current) || (pagination && pagination.pageNumber) || 1;
    const pageResults =
      (pagination && pagination.pageSize) || (pagination && pagination.pageResults) || null;

    orderBy =
      orderBy && (has(orderBy, 'orderBy') || typeof orderBy === 'string')
        ? typeof orderBy === 'string'
          ? { orderBy: orderBy }
          : orderBy
        : { orderBy: 'addedOn[desc]' };

    const search = _search || (filters && filters.search) || undefined;
    if (filters) delete filters.search;

    let formatedFilters = formatFilters(filters);

    const params = {
      filterBy: formatedFilters,
      ...orderBy,
      search,
      pageNumber,
      pageResults,
      ...(showChildrenCount ? { showChildrenCount: true } : {}),
      ...(showActions ? { showActions: true } : {})
    };

    const headers = {
      ...(authentication ? { authentication: 'true' } : {}),
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/platforms/${platformId}/teams`,
      params,
      headers
    )
      .then(result => {
        return dispatch({ type: FETCH_TEAM_SEARCH_SUCCESS, payload: result });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_TEAM_SEARCH_ERROR,
          payload: error,
          filters: filters,
          search: search
        });
      });
  };
}

export function searchCampaignTeamlessParticipants(
  campaignId,
  _search = null,
  filters = {},
  pagination = {},
  orderBy = null,
  authentication = false,) {
    return dispatch => {
    dispatch({ type: FETCH_TEAMLESS_SEARCH_START });

    const pageNumber =
      (pagination && pagination.current) || (pagination && pagination.pageNumber) || 1;
    const pageResults =
      (pagination && pagination.pageSize) || (pagination && pagination.pageResults) || null;

    orderBy =
      orderBy && (has(orderBy, 'orderBy') || typeof orderBy === 'string')
        ? typeof orderBy === 'string'
          ? { orderBy: orderBy }
          : orderBy
        : { orderBy: 'addedOn[desc]' };

    const search = _search || (filters && filters.search) || undefined;
    if (filters) delete filters.search;

    let formatedFilters = formatFilters(filters);

    const params = {
      filterBy: formatedFilters,
      ...orderBy,
      search,
      pageNumber,
      pageResults
    };

    const headers = {
      ...(authentication ? { authentication: 'true' } : {}),
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/campaigns/${campaignId}/teamless`,
      params,
      headers
    )
      .then(result => {
        return dispatch({ type: FETCH_TEAMLESS_SEARCH_SUCCESS, payload: result });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_TEAMLESS_SEARCH_ERROR,
          payload: error,
          filters: filters,
          search: search
        });
      });
  };
}

export function searchTeamsInCampaign(
  campaignId,
  _search = null,
  filters = {},
  pagination = {},
  orderBy = null,
  authentication = false,
  showChildrenCount = false,
  showParticipants = false,
) {

  return dispatch => {
    dispatch({ type: FETCH_TEAM_SEARCH_START });

    const pageNumber =
      (pagination && pagination.current) || (pagination && pagination.pageNumber) || 1;
    const pageResults =
      (pagination && pagination.pageSize) || (pagination && pagination.pageResults) || null;

    orderBy =
      orderBy && (has(orderBy, 'orderBy') || typeof orderBy === 'string')
        ? typeof orderBy === 'string'
          ? { orderBy: orderBy }
          : orderBy
        : { orderBy: 'addedOn[desc]' };

    const search = _search || (filters && filters.search) || undefined;
    if (filters) delete filters.search;

    let formatedFilters = formatFilters(filters);

    const params = {
      filterBy: formatedFilters,
      ...orderBy,
      search,
      pageNumber,
      pageResults,
      ...({ showChildrenCount: showChildrenCount, showParticipants: showParticipants })
    };

    const headers = {
      ...(authentication ? { authentication: 'true' } : {}),
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/campaigns/${campaignId}/teams`,
      params,
      headers
    )
      .then(result => {
        return dispatch({ type: FETCH_TEAM_SEARCH_SUCCESS, payload: result });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_TEAM_SEARCH_ERROR,
          payload: error,
          filters: filters,
          search: search
        });
      });
  };
}

export function searchTeamsAndParticipantsInCampaign(
  campaignId,
  _search = null,
  _participantSearch = null,
  filters = {},
  pagination = {},
  orderBy = null,
  authentication = false,
  showChildrenCount = false,
  showParticipants = false,
) {

  return dispatch => {
    dispatch({ type: FETCH_TEAM_AND_PARTICIPANT_SEARCH_START });

    const pageNumber =
      (pagination && pagination.current) || (pagination && pagination.pageNumber) || 1;
    const pageResults =
      (pagination && pagination.pageSize) || (pagination && pagination.pageResults) || null;

    orderBy =
      orderBy && (has(orderBy, 'orderBy') || typeof orderBy === 'string')
        ? typeof orderBy === 'string'
          ? { orderBy: orderBy }
          : orderBy
        : { orderBy: 'addedOn[desc]' };

    const search = _search || (filters && filters.search) || undefined;
    if (filters) delete filters.search;

     const participantSearch = _participantSearch || (filters && filters.participantSearch) || undefined;
    if (filters) delete filters.participantSearch;

    let formatedFilters = formatFilters(filters);

    const params = {
      filterBy: formatedFilters,
      ...orderBy,
      search,
      participantSearch,
      pageNumber,
      pageResults,
      ...({ showChildrenCount: showChildrenCount, showParticipants: showParticipants })
    };

    const headers = {
      ...(authentication ? { authentication: 'true' } : {}),
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/campaigns/${campaignId}/teamsAndParticipants`,
      params,
      headers
    )
      .then(result => {
        return dispatch({ type: FETCH_TEAM_AND_PARTICIPANT_SEARCH_SUCCESS, payload: result });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_TEAM_AND_PARTICIPANT_SEARCH_ERROR,
          payload: error,
          filters: filters,
          search: search
        });
      });
  };
}

export function searchParticipants(
  platformId,
  _search = null,
  filters = {},
  pagination = {},
  orderBy = null,
  authentication = false,
  showChildrenCount = false,
  showActions = false
) {
  return dispatch => {
    dispatch({ type: FETCH_PARTICIPANT_SEARCH_START });

    const pageNumber =
      (pagination && pagination.current) || (pagination && pagination.pageNumber) || 1;
    const pageResults =
      (pagination && pagination.pageSize) || (pagination && pagination.pageResults) || null;

    orderBy =
      orderBy && (has(orderBy, 'orderBy') || typeof orderBy === 'string')
        ? typeof orderBy === 'string'
          ? { orderBy: orderBy }
          : orderBy
        : { orderBy: 'addedOn[desc]' };

    const search = _search || (filters && filters.search) || undefined;
    if (filters) delete filters.search;

    let formatedFilters = formatFilters(filters);

    const params = {
      filterBy: formatedFilters,
      ...orderBy,
      search,
      pageNumber,
      pageResults,
      ...(showChildrenCount ? { showChildrenCount: true } : {}),
      ...(showActions ? { showActions: true } : {})
    };

    const headers = {
      ...(authentication ? { authentication: 'true' } : {}),
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/platforms/${platformId}/participants`,
      params,
      headers
    )
      .then(result => {
        return dispatch({ type: FETCH_PARTICIPANT_SEARCH_SUCCESS, payload: result });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_PARTICIPANT_SEARCH_ERROR,
          payload: error,
          filters: filters,
          search: search
        });
      });
  };
}

export function searchParticipantsInCampaign(
  campaignId,
  _search = null,
  filters = {},
  pagination = {},
  orderBy = null,
  authentication = false
) {
  return dispatch => {
    dispatch({ type: FETCH_PARTICIPANT_SEARCH_START });

    const pageNumber =
      (pagination && pagination.current) || (pagination && pagination.pageNumber) || 1;
    const pageResults =
      (pagination && pagination.pageSize) || (pagination && pagination.pageResults) || null;

    orderBy =
      orderBy && (has(orderBy, 'orderBy') || typeof orderBy === 'string')
        ? typeof orderBy === 'string'
          ? { orderBy: orderBy }
          : orderBy
        : { orderBy: 'addedOn[desc]' };

    const search = _search || (filters && filters.search) || undefined;
    if (filters) delete filters.search;

    let formatedFilters = formatFilters(filters);

    const params = {
      filterBy: formatedFilters,
      ...orderBy,
      search,
      pageNumber,
      pageResults
    };

    const headers = {
      ...(authentication ? { authentication: 'true' } : {}),
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/campaigns/${campaignId}/participants`,
      params,
      headers
    )
      .then(result => {
        return dispatch({ type: FETCH_PARTICIPANT_SEARCH_SUCCESS, payload: result });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_PARTICIPANT_SEARCH_ERROR,
          payload: error,
          filters: filters,
          search: search
        });
      });
  };
}

export function searchParticipantsInTeam(
  teamId,
  _search = null,
  filters = {},
  pagination = {},
  orderBy = null,
  authentication = false
) {
  return dispatch => {
    dispatch({ type: FETCH_PARTICIPANT_SEARCH_START });

    const pageNumber =
      (pagination && pagination.current) || (pagination && pagination.pageNumber) || 1;
    const pageResults =
      (pagination && pagination.pageSize) || (pagination && pagination.pageResults) || null;

    orderBy =
      orderBy && (has(orderBy, 'orderBy') || typeof orderBy === 'string')
        ? typeof orderBy === 'string'
          ? { orderBy: orderBy }
          : orderBy
        : { orderBy: 'addedOn[desc]' };

    const search = _search || (filters && filters.search) || undefined;
    if (filters) delete filters.search;

    let formatedFilters = formatFilters(filters);

    const params = {
      filterBy: formatedFilters,
      ...orderBy,
      search,
      pageNumber,
      pageResults
    };

    const headers = {
      ...(authentication ? { authentication: 'true' } : {}),
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/teams/${teamId}/participants`,
      params,
      headers
    )
      .then(result => {
        return dispatch({ type: FETCH_PARTICIPANT_SEARCH_SUCCESS, payload: result });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_PARTICIPANT_SEARCH_ERROR,
          payload: error,
          filters: filters,
          search: search
        });
      });
  };
}

export function searchDonations(
  platformId,
  _search = null,
  filters = {},
  pagination = {},
  orderBy = null,
  authentication = false
) {
  return dispatch => {
    dispatch({ type: FETCH_DONATION_SEARCH_START });

    const pageNumber =
      (pagination && pagination.current) || (pagination && pagination.pageNumber) || 1;
    const pageResults =
      (pagination && pagination.pageSize) || (pagination && pagination.pageResults) || null;

    orderBy =
      orderBy && (has(orderBy, 'orderBy') || typeof orderBy === 'string')
        ? typeof orderBy === 'string'
          ? { orderBy: orderBy }
          : orderBy
        : { orderBy: 'addedOn[desc]' };

    const search = _search || (filters && filters.search) || undefined;
    if (filters) delete filters.search;

    let formatedFilters = formatFilters(filters);

    const params = {
      filterBy: formatedFilters,
      ...orderBy,
      search,
      pageNumber,
      pageResults
    };

    const headers = {
      ...(authentication ? { authentication: 'true' } : {}),
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/platforms/${platformId}/donations`,
      params,
      headers
    )
      .then(result => {
        return dispatch({ type: FETCH_DONATION_SEARCH_SUCCESS, payload: result });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_DONATION_SEARCH_ERROR,
          payload: error,
          filters: filters,
          search: search
        });
      });
  };
}

export function searchDonationsInCampaign(
  campaignId,
  _search = null,
  filters = {},
  pagination = {},
  orderBy = null,
  authentication = false
) {
  return dispatch => {
    dispatch({ type: FETCH_DONATION_SEARCH_START });

    const pageNumber =
      (pagination && pagination.current) || (pagination && pagination.pageNumber) || 1;
    const pageResults =
      (pagination && pagination.pageSize) || (pagination && pagination.pageResults) || null;

    orderBy =
      orderBy && (has(orderBy, 'orderBy') || typeof orderBy === 'string')
        ? typeof orderBy === 'string'
          ? { orderBy: orderBy }
          : orderBy
        : { orderBy: 'addedOn[desc]' };

    const search = _search || (filters && filters.search) || undefined;
    if (filters) delete filters.search;

    let formatedFilters = formatFilters(filters);

    const params = {
      filterBy: formatedFilters,
      ...orderBy,
      search,
      pageNumber,
      pageResults
    };

    const headers = {
      ...(authentication ? { authentication: 'true' } : {}),
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/campaigns/${campaignId}/donations`,
      params,
      headers
    )
      .then(result => {
        return dispatch({ type: FETCH_DONATION_SEARCH_SUCCESS, payload: result });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_DONATION_SEARCH_ERROR,
          payload: error,
          filters: filters,
          search: search
        });
      });
  };
}

export function searchTransactions(
  platformId,
  _search = null,
  filters = {},
  pagination = {},
  orderBy = null,
  dateRange = "all",
  authentication = false
) {
  if(filters === undefined || filters === null)
    filters = {};
  return dispatch => {
    dispatch({ type: FETCH_TRANSACTION_SEARCH_START });

    const pageNumber =
      (pagination && pagination.current) || (pagination && pagination.pageNumber) || 1;
    const pageResults =
      (pagination && pagination.pageSize) || (pagination && pagination.pageResults) || null;

    orderBy = orderBy && (has(orderBy, 'orderBy') || typeof orderBy === 'string')
      ? typeof orderBy === 'string'
        ? { orderBy: orderBy }
        : orderBy
      : { orderBy: 'addedOn[desc]' };

    /* Only APPROVED for now*/
    // const status = 'APPROVED|REFUNDED';
    // if (filters) {
    //   filters.status = status;
    // } else {
    //   filters = { status: status };
    // }

    const search = _search || (filters && filters.search) || undefined;
    if (filters) delete filters.search;

    if (filters.hasOwnProperty('parentId') && isArray(filters.parentId) && filters.parentId[0] === null) filters.parentId = 'null';

    let formatedFilters = formatFilters(filters);

    const params = {
      filterBy: formatedFilters,
      dateRange: dateRange,
      ...orderBy,
      search,
      pageNumber,
      pageResults
    };

    const headers = {
      ...(authentication ? { authentication: 'true' } : {}),
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/platforms/${platformId}/transactions`,
      params,
      headers
    )
      .then(result => {
        return dispatch({ type: FETCH_TRANSACTION_SEARCH_SUCCESS, payload: result });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_TRANSACTION_SEARCH_ERROR,
          payload: error,
          filters: filters,
          search: search
        });
      });
  };
}

export function searchTransactionsInCampaign(
  campaignId,
  _search = null,
  filters = {},
  pagination = {},
  orderBy = null,
  dateRange = "all",
  authentication = false
) {
  if(filters === undefined || filters === null)
    filters = {};
  return dispatch => {
    dispatch({ type: FETCH_TRANSACTION_SEARCH_START });

    const pageNumber =
      (pagination && pagination.current) || (pagination && pagination.pageNumber) || 1;
    const pageResults =
      (pagination && pagination.pageSize) || (pagination && pagination.pageResults) || null;

    orderBy =
      orderBy && (has(orderBy, 'orderBy') || typeof orderBy === 'string')
        ? typeof orderBy === 'string'
          ? { orderBy: orderBy }
          : orderBy
        : { orderBy: 'addedOn[desc]' };

    /* Only APPROVED and REFUNDED for now*/
    // const status = 'APPROVED|REFUNDED';
    // if (filters) {
    //   filters.status = status;
    // } else {
    //   filters = { status: status };
    // }

    const search = _search || (filters && filters.search) || undefined;
    if (filters) delete filters.search;

    let formatedFilters = formatFilters(filters);

    // filterBy: type[typeName]
    // typeName: {
    //   DONATION: 1,
    //   PLUGIN: 2,
    //   CAMPAIGN_EVENT_TICKET: 3,
    //   CAMPAIGN_STREAM_POLL_VOTE: 4,
    //   CAMPAIGN_STREAM_ATTENDEE: 5
    // }

    const params = {
      filterBy: formatedFilters,
      dateRange: dateRange,
      ...orderBy,
      search,
      pageNumber,
      pageResults
    };

    const headers = {
      ...(authentication ? { authentication: 'true' } : {}),
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/campaigns/${campaignId}/transactions`,
      params,
      headers
    )
      .then(result => {
        return dispatch({ type: FETCH_TRANSACTION_SEARCH_SUCCESS, payload: result });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_TRANSACTION_SEARCH_ERROR,
          payload: error,
          filters: filters,
          search: search
        });
      });
  };
}

export function searchParticipations(
  memberId,
  platformId,
  _search = null,
  filters = {},
  pagination = {},
  orderBy = null,
  authentication = false
) {
  return dispatch => {
    dispatch({ type: FETCH_PARTICIPATION_SEARCH_START });

    const pageNumber =
      (pagination && pagination.current) || (pagination && pagination.pageNumber) || 1;
    const pageResults =
      (pagination && pagination.pageSize) || (pagination && pagination.pageResults) || null;

    orderBy =
      orderBy && (has(orderBy, 'orderBy') || typeof orderBy === 'string')
        ? typeof orderBy === 'string'
          ? { orderBy: orderBy }
          : orderBy
        : { orderBy: 'addedOn[desc]' };

    const search = _search || (filters && filters.search) || undefined;
    if (filters) delete filters.search;

    let _filters = {
      ...filters,
      platformId: platformId
    };

    let formatedFilters = formatFilters(_filters);

    const params = {
      filterBy: formatedFilters,
      ...orderBy,
      search,
      pageNumber,
      pageResults
    };

    const headers = {
      ...(authentication ? { authentication: 'true' } : {}),
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/members/${memberId}/participations`,
      params,
      headers
    )
      .then(result => {
        return dispatch({ type: FETCH_PARTICIPATION_SEARCH_SUCCESS, payload: result });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_PARTICIPATION_SEARCH_ERROR,
          payload: error,
          filters: filters,
          search: search
        });
      });
  };
}

export function searchMemberTransactions(
  memberId,
  _search = null,
  filters = {},
  pagination = {},
  orderBy = null,
  authentication = false
) {
  return dispatch => {
    dispatch({ type: FETCH_MEMBER_TRANSACTIONS_SEARCH_START });

    const pageNumber =
      (pagination && pagination.current) || (pagination && pagination.pageNumber) || 1;
    const pageResults =
      (pagination && pagination.pageSize) || (pagination && pagination.pageResults) || null;

    orderBy =
      orderBy && (has(orderBy, 'orderBy') || typeof orderBy === 'string')
        ? typeof orderBy === 'string'
          ? { orderBy: orderBy }
          : orderBy
        : { orderBy: 'addedOn[desc]' };

    const search = _search || (filters && filters.search) || undefined;
    if (filters) delete filters.search;

    if (filters.hasOwnProperty('parentId') && isArray(filters.parentId) && filters.parentId[0] === null) filters.parentId = 'null';

    let formatedFilters = formatFilters(filters);

    const params = {
      filterBy: formatedFilters,
      ...orderBy,
      search,
      pageNumber,
      pageResults
    };

    const headers = {
      ...(authentication ? { authentication: 'true' } : {}),
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/members/${memberId}/transactions`,
      params,
      headers
    )
      .then(result => {
        return dispatch({ type: FETCH_MEMBER_TRANSACTIONS_SEARCH_SUCCESS, payload: result });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_MEMBER_TRANSACTIONS_SEARCH_ERROR,
          payload: error,
          filters: filters,
          search: search
        });
      });
  };
}

export function searchMembers(
  platformId,
  _search = null,
  filters = {},
  pagination = {},
  orderBy = null
) {
  return dispatch => {
    dispatch({ type: FETCH_PLATFORM_MEMBERS_SEARCH_START });

    const pageNumber =
      (pagination && pagination.current) || (pagination && pagination.pageNumber) || 1;
    const pageResults =
      (pagination && pagination.pageSize) || (pagination && pagination.pageResults) || null;

    orderBy =
      orderBy && (has(orderBy, 'orderBy') || typeof orderBy === 'string')
        ? typeof orderBy === 'string'
          ? { orderBy: orderBy }
          : orderBy
        : { orderBy: 'addedOn[desc]' };

    const search = _search || (filters && filters.search) || undefined;
    if (filters) delete filters.search;

    let formatedFilters = formatFilters(filters);

    const params = {
      filterBy: formatedFilters,
      ...orderBy,
      search,
      pageNumber,
      pageResults
    };

    const headers = {
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/platforms/${platformId}/members`,
      params,
      headers
    )
      .then(result => {
        return dispatch({
          type: FETCH_PLATFORM_MEMBERS_SEARCH_SUCCESS,
          payload: result
        });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_PLATFORM_MEMBERS_SEARCH_ERROR,
          payload: error,
          filters: filters,
          search: search
        });
      });
  };
}

export function searchPlatformMembersParticipations(
  platformId,
  memberId,
  _search = null,
  filters = {},
  pagination = {},
  orderBy = null
) {
  return dispatch => {
    dispatch({ type: FETCH_PLATFORM_MEMBERS_PARTICIPATIONS_SEARCH_START });

    const pageNumber =
      (pagination && pagination.current) || (pagination && pagination.pageNumber) || 1;
    const pageResults =
      (pagination && pagination.pageSize) || (pagination && pagination.pageResults) || null;

    orderBy =
      orderBy && (has(orderBy, 'orderBy') || typeof orderBy === 'string')
        ? typeof orderBy === 'string'
          ? { orderBy: orderBy }
          : orderBy
        : { orderBy: 'addedOn[desc]' };

    const search = _search || (filters && filters.search) || undefined;
    if (filters) delete filters.search;

    let formatedFilters = formatFilters(filters);

    const params = {
      filterBy: formatedFilters,
      ...orderBy,
      search,
      pageNumber,
      pageResults
    };

    const headers = {
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/platforms/${platformId}/members/${memberId}/participations`,
      params,
      headers
    )
      .then(result => {
        return dispatch({
          type: FETCH_PLATFORM_MEMBERS_PARTICIPATIONS_SEARCH_SUCCESS,
          payload: result
        });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_PLATFORM_MEMBERS_PARTICIPATIONS_SEARCH_ERROR,
          payload: error,
          filters: filters,
          search: search
        });
      });
  };
}

export function searchPlatformMembersTransactions(
  platformId,
  memberId,
  _search = null,
  filters = {},
  pagination = {},
  orderBy = null
) {
  return dispatch => {
    dispatch({ type: FETCH_PLATFORM_MEMBERS_TRANSACTIONS_SEARCH_START });

    const pageNumber =
      (pagination && pagination.current) || (pagination && pagination.pageNumber) || 1;
    const pageResults =
      (pagination && pagination.pageSize) || (pagination && pagination.pageResults) || null;

    orderBy =
      orderBy && (has(orderBy, 'orderBy') || typeof orderBy === 'string')
        ? typeof orderBy === 'string'
          ? { orderBy: orderBy }
          : orderBy
        : { orderBy: 'addedOn[desc]' };

    const search = _search || (filters && filters.search) || undefined;
    if (filters) delete filters.search;

    if (filters.hasOwnProperty('parentId') && isArray(filters.parentId) && filters.parentId[0] === null) filters.parentId = 'null';

    let formatedFilters = formatFilters(filters);

    const params = {
      filterBy: formatedFilters,
      ...orderBy,
      search,
      pageNumber,
      pageResults
    };

    const headers = {
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/platforms/${platformId}/members/${memberId}/transactions`,
      params,
      headers
    )
      .then(result => {
        return dispatch({
          type: FETCH_PLATFORM_MEMBERS_TRANSACTIONS_SEARCH_SUCCESS,
          payload: result
        });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_PLATFORM_MEMBERS_TRANSACTIONS_SEARCH_ERROR,
          payload: error,
          filters: filters,
          search: search
        });
      });
  };
}

export function searchPlugins(
  _search = null,
  filters = {},
  pagination = {},
  orderBy = null,
  authentication = false
) {
  return dispatch => {
    dispatch({ type: FETCH_PLUGIN_SEARCH_START });

    const pageNumber =
      (pagination && pagination.current) || (pagination && pagination.pageNumber) || 1;
    const pageResults =
      (pagination && pagination.pageSize) || (pagination && pagination.pageResults) || null;

    orderBy =
      orderBy && (has(orderBy, 'orderBy') || typeof orderBy === 'string')
        ? typeof orderBy === 'string'
          ? { orderBy: orderBy }
          : orderBy
        : { orderBy: 'addedOn[desc]' };

    const search = _search || (filters && filters.search) || undefined;
    if (filters) delete filters.search;

    let formatedFilters = formatFilters(filters);

    const params = {
      filterBy: formatedFilters,
      ...orderBy,
      search,
      pageNumber,
      pageResults
    };

    const headers = {
      ...(authentication ? { authentication: 'true' } : {}),
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/plugins`,
      params,
      headers
    )
      .then(result => {
        return dispatch({ type: FETCH_PLUGIN_SEARCH_SUCCESS, payload: result });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_PLUGIN_SEARCH_ERROR,
          payload: error,
          filters: filters,
          search: search
        });
      });
  };
}

export function searchSettlementReports(
  organizationId,
  _search = null,
  filters = {},
  pagination = {},
  orderBy = null,
  authentication = false
) {
  return dispatch => {
    dispatch({ type: FETCH_SETTLEMENT_REPORTS_START });

    const pageNumber =
      (pagination && pagination.current) || (pagination && pagination.pageNumber) || 1;
    const pageResults =
      (pagination && pagination.pageSize) || (pagination && pagination.pageResults) || null;

    orderBy =
      orderBy && (has(orderBy, 'orderBy') || typeof orderBy === 'string')
        ? typeof orderBy === 'string'
          ? { orderBy: orderBy }
          : orderBy
        : { orderBy: 'addedOn[desc]' };

    const search = _search || (filters && filters.search) || undefined;
    if (filters) delete filters.search;

    let formatedFilters = formatFilters(filters);

    const params = {
      filterBy: formatedFilters,
      ...orderBy,
      search,
      pageNumber,
      pageResults
    };

    const headers = {
      ...(authentication ? { authentication: 'true' } : {}),
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/organizations/${organizationId}/reports/withdrawals`,
      params,
      headers
    )
      .then(result => {
        return dispatch({ type: FETCH_SETTLEMENT_REPORTS_SUCCESS, payload: result });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_SETTLEMENT_REPORTS_ERROR,
          payload: error,
          filters: filters,
          search: search
        });
      });
  };
}

export function searchFlaggedMessages(
  platformId,
  search = null,
  showResolved = false,
  pagination = {},
  orderBy = null,
  authentication = true
) {
  return dispatch => {
    dispatch({ type: FETCH_FLAGGED_SEARCH_START });

    const pageNumber =
      (pagination && pagination.current) || (pagination && pagination.pageNumber) || 1;
    const pageResults =
      (pagination && pagination.pageSize) || (pagination && pagination.pageResults) || 10;

    orderBy =
      orderBy && (has(orderBy, 'orderBy') || typeof orderBy === 'string')
        ? typeof orderBy === 'string'
          ? { orderBy: orderBy }
          : orderBy
        : { orderBy: 'addedOn[desc]' };


    const params = {
      ...orderBy,
      showResolved,
      search,
      pageNumber,
      pageResults
    };

    const headers = {
      ...(authentication ? { authentication: 'true' } : {}),
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/messages/${platformId}/flagged`,
      params,
      headers
    )
      .then(result => {
        return dispatch({ type: FETCH_FLAGGED_SEARCH_SUCCESS, payload: {
          ...result,
        }});
      })
      .catch(error => {
        return dispatch({
          type: FETCH_FLAGGED_SEARCH_ERROR,
          payload: error,
          search: search
        });
      });
  };
}

export function searchMessages(
  platformId,
  _search = null,
  filters = {},
  pagination = {},
  orderBy = null,
  authentication = true
) {

  return dispatch => {
    dispatch({ type: FETCH_MESSAGES_SEARCH_START });

    const pageNumber =
      (pagination && pagination.current) || (pagination && pagination.pageNumber) || 1;

    orderBy =
      orderBy && (has(orderBy, 'orderBy') || typeof orderBy === 'string')
        ? typeof orderBy === 'string'
          ? { orderBy: orderBy }
          : orderBy
        : { orderBy: 'addedOn[desc]' };

    const search = _search || (filters && filters.search) || undefined;
    if (filters) delete filters.search;

    let formatedFilters = formatFilters(filters);

    const params = {
      filterBy: formatedFilters,
      ...orderBy,
      search,
      pageNumber
    };

    const headers = {
      ...(authentication ? { authentication: 'true' } : {}),
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/messages/` + platformId,
      params,
      headers
    )
      .then(result => {
        return dispatch({ type: FETCH_MESSAGES_SEARCH_SUCCESS, payload: {
          ...result,
          fetchTime: new Date() } });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_MESSAGES_SEARCH_ERROR,
          payload: error,
          filters: filters,
          search: search
        });
      });
  };
}

export function searchDrafts(
  platformId,
  _search = null,
  filters = {},
  pagination = {},
  orderBy = null,
  authentication = true
) {
  return dispatch => {
    dispatch({ type: FETCH_DRAFTS_SEARCH_START });

    const pageNumber =
      (pagination && pagination.current) || (pagination && pagination.pageNumber) || 1;
    const pageResults =
      (pagination && pagination.pageSize) || (pagination && pagination.pageResults) || null;

    orderBy =
      orderBy && (has(orderBy, 'orderBy') || typeof orderBy === 'string')
        ? typeof orderBy === 'string'
          ? { orderBy: orderBy }
          : orderBy
        : { orderBy: 'addedOn[desc]' };

    const search = _search || (filters && filters.search) || undefined;
    if (filters) delete filters.search;

    let formatedFilters = formatFilters(filters);

    const params = {
      filterBy: formatedFilters,
      ...orderBy,
      search,
      pageNumber,
      pageResults
    };

    const headers = {
      ...(authentication ? { authentication: 'true' } : {}),
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/messages/${platformId}/drafts`,
      params,
      headers
    )
      .then(result => {
        return dispatch({ type: FETCH_DRAFTS_SEARCH_SUCCESS, payload: {
          ...result,
          fetchTime: new Date() } });
      })
      .catch(error => {
        return dispatch({
          type: FETCH_DRAFTS_SEARCH_ERROR,
          payload: error,
          filters: filters,
          search: search
        });
      });
  };

}

export function searchCampaignRecipients(
  platformId,
  search = null,
  batchNumber = 1,
  captains_only = false,
  authentication = true
) { 
   return dispatch => {
    dispatch({ type: FETCH_CAMPAIGN_RECIPIENTS_SEARCH_START });

    const params = {
      search: typeof search === 'string' ? search : undefined,
      id: typeof search === 'number' ? search : undefined,
      batchNumber: batchNumber,
      captains_only: captains_only
    };

    const headers = {
      ...(authentication ? { authentication: 'true' } : {}),
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/messages/${platformId}/recipients/campaigns`,
      params,
      headers
    )
      .then(result => {
        return dispatch({ type: FETCH_CAMPAIGN_RECIPIENTS_SEARCH_SUCCESS, payload: result});
      })
      .catch(error => {
        return dispatch({
          type: FETCH_CAMPAIGN_RECIPIENTS_SEARCH_ERROR,
          payload: error,
          search: search
        });
      });
  };
}

export function searchTeamRecipients(
  platformId,
  campaignId,
  search = null,
  batchNumber = 1,
  authentication = true
) { 
   return dispatch => {
    dispatch({ type: FETCH_TEAM_RECIPIENTS_SEARCH_START });

    const params = {
      search: typeof search === 'string' ? search : undefined,
      id: typeof search === 'number' ? search : undefined,
      batchNumber: batchNumber,
      campaignId: typeof campaignId === 'number' ? campaignId : undefined
    };

    const headers = {
      ...(authentication ? { authentication: 'true' } : {}),
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/messages/${platformId}/recipients/teams`,
      params,
      headers
    )
      .then(result => {
        return dispatch({ type: FETCH_TEAM_RECIPIENTS_SEARCH_SUCCESS, payload: result});
      })
      .catch(error => {
        return dispatch({
          type: FETCH_TEAM_RECIPIENTS_SEARCH_ERROR,
          payload: error,
          search: search
        });
      });
  };
}

export function searchMemberRecipients(
  platformId,
  campaignId,
  teamIds,
  search = null,
  batchNumber = 1,
  captainsOnly,
  authentication = true
) {
   return dispatch => {
    dispatch({ type: FETCH_MEMBER_RECIPIENTS_SEARCH_START });

    const params = {
      search: typeof search === 'string' ? search : undefined,
      id: typeof search === 'number' ? search : undefined,
      campaignId: typeof campaignId === 'number' ? campaignId : undefined,
      teamIds: teamIds,
      batchNumber: batchNumber,
      captains_only: captainsOnly
    };

    const headers = {
      ...(authentication ? { authentication: 'true' } : {}),
      ...dispatch(getSessionIp())
    };

    return requestApiGet(
      `/messages/${platformId}/recipients/members`,
      params,
      headers
    )
      .then(result => {
        return dispatch({ type: FETCH_MEMBER_RECIPIENTS_SEARCH_SUCCESS, payload: result});
      })
      .catch(error => {
        return dispatch({
          type: FETCH_MEMBER_RECIPIENTS_SEARCH_ERROR,
          payload: error,
          search: search
        });
      });
  };
}

// ALGOLIA TOKEN
export function getAlgoliaToken(platformId, index) {
  return dispatch => {
    dispatch({ type: FETCH_ALGOLIA_TOKEN_START });

    const params = {
      'platformId':platformId,
      'index':index
    };

    const headers = {
      ...(authentication ? { authentication: 'true' } : {}),
      ...dispatch(getSessionIp())
    };

    return requestApiPost(
      `/tools/algolia/securedKey`,
      params,
      headers
    )
      .then(result => {
        return dispatch({ type: FETCH_ALGOLIA_TOKEN_SUCCESS, payload: result })
      })
      .catch(error => {
        return dispatch({type: FETCH_SETTLEMENT_REPORTS_ERROR, payload: error})
      });
  }
}


export function clearSearch() {
  return dispatch => {
    return dispatch({ type: CLEAR_SEARCH });
  };
}

const formatFilters = filters => {
  let formatedFilters = [];
  for (let key in filters) {
    if (filters[key] === null || filters[key] === "NULL" || filters[key]  === undefined) continue;

    let filter = Array.isArray(filters[key]) ? filters[key].join('|') : filters[key];

    formatedFilters.push(`${key}[${filter}]`);
  }
  return formatedFilters.length > 0 ? formatedFilters.join(',') : undefined;
};
